import { Color } from '../models';
import colors from './colors';
const buttons = {
    buttonHeight: '3rem',
    borderRadius: '0.375rem',
    fontWeight: 'bold',
    fontSize: '1.125rem',
    fontSizeMobile: '1rem',
    smallButtonHeight: '1.875rem',
    smallButtonFontSize: '1rem',
    smallButtonFontSizeMobile: '1rem',
    rightIconMargin: '0 -0.25rem 0 1rem',
    defaultIconMargin: '0 0.563rem 0 0',
    loadingSpinnerSize: '2.875rem',
    textColor: colors.white,
    primary: {
        backgroundColor: colors.primaryDark,
        hoverFocusBackgroundColor: colors.primaryDark,
        color: colors.white,
    },
    secondary: {
        backgroundColor: colors.grayD10,
        hoverFocusBackgroundColor: colors.grayD40,
        color: colors.white,
    },
    light: {
        backgroundColor: colors.white,
        color: colors.grayD40,
        border: `1px solid ${Color.DARK}`,
        hoverFocusBackgroundColor: colors.grayL40,
        hoverFocusBorder: `1px solid ${colors.grayD40}`,
    },
    dark: {
        backgroundColor: colors.grayD40,
        hoverFocusBackgroundColor: colors.black,
        color: colors.white,
    },
};
export default buttons;
//# sourceMappingURL=buttons.js.map